<template>
  <a-modal title="填写获奖内容" :width="980" :visible="visible" :confirmLoading="confirmLoading" :maskClosable="false"   @ok="handleSubmit"
    v-if="hackReset" @cancel="handleCancel" okText="确定并发送通知">
    <div class="viewDetial-tiem">
      <a-form  :form="form">
        <a-form-item label="">
          <span class="userName"> {{queryParam.userInfo.userName}} &emsp; &emsp;{{ queryParam.userInfo.points}}分  &emsp;&emsp; <span v-if="queryParam.userInfo.totalAmount">{{ queryParam.userInfo.totalAmount}}元</span>  &emsp;&emsp; {{ queryParam.userInfo.mobile }} </span>
          </a-form-item>
          <a-form-item 
          label="领取方式"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          >
            <a-radio-group  buttonStyle="solid" v-decorator="['receiveType',{rules: [{ required: true, message: '请选择领取方式！' }]}]" >
              <a-radio value="0">物流配送</a-radio>
              <a-radio value="1">到院领取</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item 
          label="领取日期" 
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
          >
            <a-date-picker style="width:300px" placeholder="请选择"  v-decorator="['receiveDate', {rules: [{ required: true, message: '请选择领取日期' }]}]" />
          </a-form-item>
          <a-form-item 
          label="奖品名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
          >
            <a-input   placeholder="最多10个字"  :max='10'  v-decorator="['reward', {rules: [{ required: true, message: '请输入奖品名称' }]}]"/>
          </a-form-item>
          <a-form-item 
          label="备注"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
          >
            <a-textarea :rows="4"   v-model="queryParam.remarks" allow-clea></a-textarea>
            <span style="color:#ec808d">*点击【确定并发送通知】后，将会给兑换人的手机号发送短信通知</span>
          </a-form-item>
      </a-form>
      <!-- <div style="border-bottom: 1px dotted #ccc;margin: 10px 0 ;"></div> -->


    </div>

    <a-modal :visible="previewVisible" width="900px" height="450px"  style="overflow:hidden" :closable="false"
      :footer="null" @cancel="handleCancelImage">
      <img alt="example" style="width: 300px;transform: rotate(0deg) translateY(0px) translateX(280px);"
        :src="previewImage" />
    </a-modal>
    <a-modal :visible="isifram" width="900px" height="500px" style="overflow:hidden" :closable="true"
      @cancel="handleIframBack">
      <iframe style="width:100%;height:500px" :src="iframeSrc" frameborder="0"></iframe>
    </a-modal>
  </a-modal>
</template>

<script>
  import { STable } from '@/components';
  import moment from 'moment'
  import {sendRewardSingle} from '@/api/modular/interhospital/integral/integralManage'
  export default {
    components:{
      STable
    },
    data () {
      return {
        iframeSrc: '',
        isifram : false,
        queryParam : {
          userInfo:'',
          receiveType:'0',
          receiveDate:'',
          reward:'',
          remarks:'',
          userType:'',
        },
        visible: false,
        hackReset : true,
        kg : '',
        // 审核通过按钮防多次点击
        approved : false,
        // 审核不通过
        failedApproved : false,
        // 查看签名缩略图
        previewVisible : false,
        previewImage : '',

        refuse : false,
        refuseReason : '',
        
        labelCol: {
          xs: { span: 24 },
          sm: { span: 2 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 15 }
        },
        verifytimeDateString: '',
        
        confirmLoading: false,
        form: this.$form.createForm(this),
        loadUser : [],
        // 是否外配处方
        isPharmacyName : "",
      }
    },
    created(){
      this.loadUser = [];
    },
    methods: {
      moment,
      // 初始化方法
      add (record,tabCode) {
        console.log('获奖感言',record,tabCode)
        this.queryParam.userInfo = record;
        this.queryParam.userType = tabCode;
        this.queryParam.id = record.id;
        this.visible = true;
      },
           /**
       * 提交表单
       */
       handleSubmit () {
        const { form: { validateFields } } = this
        this.confirmLoading = true
        validateFields((errors, values) => {
          if (!errors) {
            console.log('奖品名称长度',values.reward.length)
            if(values.reward.length>10){
              this.$message.warning('奖品名称最多10个字')
              this.confirmLoading = false
              return
            }
            let obj = {
              userInfo:{
                userId : this.queryParam.userInfo.userId,
                userName:  this.queryParam.userInfo.userName,
                mobile : this.queryParam.userInfo.mobile
              },
              userType:this.queryParam.userType,
              reward:values.reward,
              receiveDate: moment(values.receiveDate._d).format('YYYY-MM-DD'),
              receiveType:this.queryParam.receiveType,
              remarks:this.queryParam.remarks
            }
            console.log('这个参',obj)
            sendRewardSingle(obj).then((res) => {
              this.confirmLoading = false
              if (res.success) {
                this.$message.success('发送成功')
                this.visible = false
                this.$emit('ok', values)
                this.form.resetFields()
              } else {
                this.$message.error('发送失败：' + res.message)
              }
            })
          } else {
            this.confirmLoading = false
          }
        })
      },
      //点击取消按钮
      handleCancel () {
        this.visible = false;
        this.hackReset = false;
        this.$nextTick(()=>{
          this.hackReset = true;
        })
      },
      // 点击查看大图
      seeIamge(type){
        if(type == 'ysSign'){
          this.previewImage = 'data:image/png;base64,' + this.loadUser.ysSign
        }else if(type == 'drSign'){
          this.previewImage = 'data:image/png;base64,' + this.loadUser.drSign
        }
        this.visible = false;
        this.previewVisible = true;
      },
      // 关闭缩略图
      handleCancelImage(){
        this.previewVisible = false;
        this.visible = true;
      },
      handleIframBack() {
        this.isifram = false;
        this.$parent.handleOk();
      }
    },
  }
</script>
<style lang="less" scoped>
.viewDetial-title{
  height: 40px;
  line-height: 40px;
  font-family: "PingFang SC ", "PingFang SC", sans-serif;
  font-weight: 650;
  font-style: normal;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.847);
  margin-bottom: 20px;
}
/deep/.s-table-tool{
  display: none;
}
.totalPrice{
  line-height: 30px;
  padding: 0 30px;
}
.detialImage{
  width: 80px;
  height: 30px;
  margin: 0 10px;
  cursor: pointer;
  
  // transform: rotate();
}
.userName{
  color:#49caab;
  font-weight: bold;
  font-size: 16PX;
  display: inline-block;
}
.ant-form-item{
  // display: flex;
  margin-bottom: 0PX;
  margin-bottom: 20px;
  
}
.ant-form-vertical .ant-form-item-label, .ant-col-24.ant-form-item-label, .ant-col-xl-24.ant-form-item-label{
  padding-right: 16px;
  margin-right: 16px;
}
</style>
